import { getColor } from '../../../../theme-tools';
import { inputBaseStyles } from '../commonBasedStyles';
var {
  base,
  disabled,
  focus,
  invalid,
  invalidFocus
} = inputBaseStyles;
var baseStyle = _ref => {
  var {
    theme
  } = _ref;
  return {
    container: {
      '.tqc-select': {
        '&--is-invalid .tqc-select__control': {
          borderStyle: 'solid',
          borderWidth: invalid.borderWidth,
          borderColor: "".concat(getColor(theme, invalid.borderColor)),
          _focusWithin: {
            boxShadow: "0 0 4px 1px ".concat(getColor(theme, invalidFocus.boxShadowColor))
          }
        }
      },
      '.tqc-select__control': {
        borderStyle: 'solid',
        borderWidth: base.borderWidth,
        borderColor: "".concat(getColor(theme, base.borderColor)),
        borderRadius: base.borderRadius,
        '&--is-focused': {
          boxShadow: "0 0 4px 1px ".concat(getColor(theme, focus.boxShadowColor))
        },
        '&--is-disabled': {
          borderStyle: 'solid',
          borderWidth: disabled.borderWidth,
          borderColor: "".concat(getColor(theme, disabled.borderColor)),
          bg: disabled.bg,
          '.tqc-select__placeholder': {
            color: 'grey.800'
          },
          '.tqc-select__indicators': {
            color: 'grey.800'
          }
        }
      },
      '.tqc-select__indicators': {
        color: 'blue.275'
      }
    },
    menu: {
      '.tqc-select__option': {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '-0.2px',
        color: 'black',
        padding: '10px 1rem',
        bg: 'white',
        '&--is-focused': {
          bg: 'neutral.7'
        },
        '&:hover': {
          bg: 'neutral.2'
        },
        '&:active': {
          bg: 'neutral.5'
        }
      }
    }
  };
};
export var Select = {
  baseStyle
};